import { createAction } from '@ngrx/store';

const userNotAuthenticated = createAction(
  '[Authentication Guard] User Not Authenticated',
);

export const authenticationGuardActions = {
  userNotAuthenticated,
};
